import { LoadFormList } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { HttpClient, HttpStatusCode } from '../protocols/http'

export class RemoteLoadFormList implements LoadFormList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadFormList.Response>
  ) {}

  async load(searchText?: string): Promise<LoadFormList.Model[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        q: searchText
      }
    })
    const response = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return formatResponse(response)
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadFormList {
  export type Form = {
    id: number
    name: string
    created_at: string
    updated_at: string
  }
  export type Response = {
    results: Form[]
  }
}

const formatResponse = (forms: RemoteLoadFormList.Response): LoadFormList.Model[] => {
  return forms?.results.map(form => ({
    id: form.id,
    name: form.name,
    createdAt: form.created_at,
    updatedAt: form.updated_at,
  })) || []
}
